import { withState } from "@mna/react";
import LoadingScreen from "features/LoadingScreen";

const BasePage = ({ state }) => {
  return (
    <LoadingScreen isLoading={state.isLoading}>
      <></>
    </LoadingScreen>
  );
};

export default withState({
  async didMount({ state, actions, history }) {
    var accessToken = localStorage.getItem("accessToken");
    if (accessToken === null && !state.IsValidUser) {
      actions.clearTriageSession();
      actions.startAzureLogin();
    } else {
      var currentUrl = window.location.pathname;
      if (currentUrl === "/") {
        history.push("/terms");
      }
    }
  },
})(BasePage);
